import { doOpenDrawer } from 'ducks/drawers/actions'
import { DRAWER_TICKET_MERGE } from 'ducks/drawers/types'

export const doOpenTicketMergeDrawer = ticketId => dispatch => {
  dispatch(doOpenDrawer(ticketId, DRAWER_TICKET_MERGE, ticketId))
}
